<template>
  <!--    1522011-->
  <div class="modal-backdrop">
    <div class="modal-universal">
      <header class="modal-header">
        <slot name="header">
          <h2>{{ modalHeader }}</h2>

          <button type="button"
                  class="btn-close"
                  @click="close"> x
          </button>
        </slot>
      </header>
      <div class="modal-body">
        <slot name="body">
          <div class="universal_modal-content">{{ modalContent }}</div>
          <transition-group name="list" tag="div" class="elements-container">
            <div v-for="(param, param_id) in getBafNumber" v-if="param.active" class="element"
                 :key="param.title">
              <div class="row" v-if="param.type==='row'">
                <div v-for="(option, option_id) in param.options"
                     class="param-container">
                  <h3 class="title" v-html="translate(option.title_translation_code)"/>
                  <div class="option-container" :class="{locked: option.locked}" v-if="option.type === 'value'">
                    <input :id="`param_${param_id}_option_${option_id}`"
                           :ref="`ref_param_${param_id}_option_${option_id}`"
                           type="text"
                           @input="setFilter(param_id, option, option_id, $event.target.value, false, $event)"
                           @focusout="setFilter(param_id, option, option_id, $event.target.value, true, $event)"
                           @focusin="setInputValue($event, option.value)"
                    >
                    <label @click="focusOnElementOfRef(`ref_param_${param_id}_option_${option_id}`)">
                      {{ option.value }} {{ option.unit.name }}
                    </label>
                  </div>
                  <div class="option-container" :class="{locked: option.locked}"
                       v-else-if="option.type === 'value_min_max'">
                    <label>
                      {{ option.value_min }} - {{ option.value_max }} {{ option.unit.name }}
                    </label>
                  </div>
                </div>
              </div>

              <h3 class="title" v-if="param.type!=='row'" v-html="translate(param_id)"/>

              <div v-if="param.type!=='row'"
                   v-for="(option, option_id) in param.options"
                   class="option-container"
                   :class="{radio_type : option.type === 'radio', select_type : option.type === 'select',}">

                <div v-if="option.type === 'radio'"
                     v-for="(element, element_id) in option.elements"
                     class="radio-btn"
                     :class="{checked : element.active, 'locked': element.locked}">
                  <input type="radio"
                         :id="'baf_' + param_id + '_' + option_id + '_' + element_id"
                         :value="element.value"
                         :disabled="element.locked"
                         :checked="element.active"
                         @change="selectElementOfOptionInParamBaf(param_id, option_id, element_id)"
                         hidden>
                  <label :for="'baf_' + param_id + '_' + option_id + '_' + element_id"
                         v-html="translate((element.displayValue ? element.displayValue : element.value), false)"/>
                </div>
              </div>
            </div>
          </transition-group>
        </slot>
      </div>
      <footer class="modal-footer">
        <slot name="footer">
          <div class="navi-btns">
            <a @click="routeToBafa" class="back-btn">
              <button @click="close" class="summary-btn" :disabled="lockSearchButton">{{
                  translate(modalButtonTitle)
                }}
              </button>
            </a>
          </div>
        </slot>
      </footer>
    </div>
  </div>
</template>

<script>
  import debounce from "lodash.debounce";

  export default {
    name: "UniversalModal",
    data() {
      return {
        value: '',
        isIncorrect: false,
        inputData: [],
        paramsChanges: [],
        lockSearchButton: false,
      }
    },
    props: ['modalHeader', 'modalContent', 'view', 'modalButtonTitle'],
    methods: {
      focusOnElementOfRef(ref) {
        let myRef = this.$refs[ref]
        myRef = Array.isArray(myRef) ? myRef[0] : myRef

        if (myRef) {
          myRef.focus();
        }
      },

      setInputValue(event, value) {
        if (event.target) {
          event.target.value = value
        }
      },

      setFilter(element, value, option_id, type, forceUpdate = false, hook) {
        hook.preventDefault();

        if (forceUpdate) {
          this.paramsChanges = [];
          this.changeParamValue(element, value, option_id, type, forceUpdate, hook);
        } else {
          this.paramsChanges.push({
            element, value, option_id, type, forceUpdate, hook
          });
          this.filterValues();
        }
      },

      filterValues: debounce(function () {
        for (let change in this.paramsChanges) {
          if (isNaN(change)) break;
          let a = this.paramsChanges[change];
          this.changeParamValue(a.element, a.value, a.option_id, a.type, a.forceUpdate, a.hook);
        }
        this.paramsChanges = [];
      }, 100),

      changeParamValue(param_id, option, option_id, value, forceUpdate, hook) {
        if ((value === '' || null) && !forceUpdate) {
          return;
        }

        if (window.mouseDown && !forceUpdate)
          return;

        let tmpRound = {
          type: 'roundValue',
          elements: {0: option},
          value: value,
          displayUser: true,
          out: ""
        }

        this.$store.commit("roundValue", tmpRound);
        let minValue = this.getBafNumber[param_id].options[option_id].min_value;

        if ((!tmpRound.out.endsWith(".") && (!isNaN(tmpRound.out) && (parseFloat(tmpRound.out) >= minValue)) || parseFloat(tmpRound.out) < 0) || forceUpdate) {
          let valueUpdatePayload = {
            type: 'setBafaParamValue',
            param_id: param_id,
            option_id: option_id,
            value: tmpRound.out
          }

          this.$store.commit(valueUpdatePayload);
          option.value = valueUpdatePayload.out;
          hook.target.value = option.value;

          if (isNaN(option.value)) {
            forceUpdate = true
          } else {
            this.lockSearchButton = false;
          }
        } else {
          this.lockSearchButton = true;
        }

        if (forceUpdate) {
          if (isNaN(option.value)) {
            this.$store.commit({
              type: 'setBafaParamValue',
              param_id: param_id,
              option_id: option_id,
              value: 1
            });
          }

          hook.target.value = option.value;
          this.lockSearchButton = false;
        }

        if (isNaN(hook.target.value)) {
          hook.target.value = isNaN(tmpRound.out) ? "" : tmpRound.out;
        }
      },

      routeToBafa() {
        Vue.set(this.$store.state, 'bafaSearchActive', Math.random());
        if (this.$route.name !== 'bafa_tables') {
          this.$router.push('/bafa_tables');
        }
      },

      toggleExpandOfCustomSelect(e) {

        let target = e.target;

        document.querySelectorAll('.custom-select').forEach((select) => {

          select.classList.remove("expanded");
        });

        while (target instanceof Element) {

          if (target.classList.contains('selected_item')) {

            target.parentElement.classList.toggle("expanded");
            return;

          } else if (
              target.classList.contains('value') ||
              target.classList.contains('icon-bottom_arrow')) {

            target.parentElement.parentElement.classList.toggle("expanded");
            return;

          } else if (target.classList.contains('items-container')) {

            target.parentElement.classList.remove("expanded");
            return;

          } else if (target.classList.contains('item')) {

            target.parentElement.parentElement.classList.remove("expanded");
            return;

          } else {
            return;
          }
        }
      },

      translate(code, displayErrors = true) {
        let arg = {
          type: 'translate',
          code: code,
          displayErrors: displayErrors,
          out: ""
        }

        this.$store.commit(arg);

        return arg.out;
      },

      close() {
        this.$emit('close');
      },

      getStep(option) {
        let arg = {
          type: 'getActiveElementOfParamOption',
          option: option,
          out: 0
        }

        this.$store.commit(arg);

        let zero = "0";
        let decimalPlaces = 0;

        if (arg.out && arg.out.unit && arg.out.unit.decimal_places)
          decimalPlaces = parseInt(arg.out.unit.decimal_places);

        if (decimalPlaces <= 0) {
          return zero;
        } else {
          return "0." + zero.repeat(decimalPlaces - 1) + 1;
        }
      },

      calcUnit(param, option) {
        if (param.value == "nieobliczalne" || param.value == "+nieskończoność" || param.value == "-nieskończoność")
          return "-";

        if (!option.hasOwnProperty('unitType'))
          return param.value;

        let arg = {
          type: 'calcUnit',
          param: param,
          option: option,
          out: ""
        }

        this.$store.commit(arg);

        return arg.out;
      },

      selectElementOfOptionInParamBaf(param_id, option_id, element_id) {
        this.$store.commit({
          type: 'selectElementOfOptionInParamBaf',
          param_id: param_id,
          option_id: option_id,
          element_id: element_id
        });
      },

      setWorkFrequencyBasedOnNetworkFrequency() {
        if (this.network_frequency && this.$store.state.bafaParameters.work_frequency.options[0].locked) {
          this.$store.state.bafaParameters.work_frequency.options[0].value = this.network_frequency
        }
      }
    },

    computed: {
      getBafNumber() {
        return this.$store.state.bafaParameters;
      },
      work_on_the_inverter() {
        return this.$store.state.bafaParameters.work_on_the_inverter.options[0].elements[1].active;
      },
      network_frequency() {
        let selectedParameters = this.$store.state.bafaParameters;

        for (let option in selectedParameters.network_frequency.options[0].elements) {
          if (selectedParameters.network_frequency.options[0].elements.hasOwnProperty(option)) {
            if (selectedParameters.network_frequency.options[0].elements[option].active) {
              return selectedParameters.network_frequency.options[0].elements[option].value;
            }
          }
        }

        return null;
      }
    },

    watch: {
      work_on_the_inverter(newVal) {
        this.$store.state.bafaParameters.work_frequency.options[0].locked = !newVal;

        this.setWorkFrequencyBasedOnNetworkFrequency();
      },
      network_frequency() {
        this.setWorkFrequencyBasedOnNetworkFrequency();
      }
    },

    mounted() {
      this.$on('validateData', (d) => {

        if (!this.inputData.some(item => item.inputName === d.inputName)) {

          this.inputData.push(d)

        } else if (this.inputData.some(item => item.inputName === d.inputName)) {

          this.inputData.forEach((element) => {

            if (element.inputName === d.inputName) {

              element.inputName = d.inputName;
              element.isIncorect = d.isIncorect;
              element.value = d.value ? d.value : '';
            }
          })
        }
      });
    },

    beforeDestroy() {
      this.$off('validateData');
    }
  }
</script>